import React from "react";
import Styled, { CustomModal, LineBreak } from "./styles";
import { groupBy, keyBy, mapValues } from "lodash";

const getData = (features, round) => {
  return mapValues(
    groupBy(
      features.filter(i => i.round_number === round),
      "rank"
    ),
    i => mapValues(keyBy(i, "type"), i => i.material_cpu.toFixed(2))
  );
};

const ModalExhibit3 = ({ features, activeRound, goBack }) => (
  <CustomModal goBack={goBack}>
    <b>EXHIBIT 3 - Estimated Direct Material Costs</b>
    <LineBreak />
    <Styled.ModalTable>
      <tbody>
        <tr>
          <th>Rank</th>
          <th>Resolution</th>
          <th>Sensitivity</th>
          <th>Power</th>
          <th>Temperature</th>
        </tr>
        {Object.keys(getData(features, activeRound)).map(rank => {
          const feature = getData(features, activeRound)[rank];
          return (
            <tr key={rank}>
              <td>{rank}</td>
              <td>${feature["Pixels"]}</td>
              <td>${feature["Sensitivity"]}</td>
              <td>${feature["Power"]}</td>
              <td>${feature["Temperature Range"]}</td>
            </tr>
          );
        })}
      </tbody>
    </Styled.ModalTable>
  </CustomModal>
);

export default ModalExhibit3;



// WEBPACK FOOTER //
// ./src/components/bcase/ModalExhibit3.js